module.exports = __webpack_public_path__ + "img/partner_antennahungaria.ac96221b.png";